import React from 'react';
import './About.css';
import portfolioData from '../data/portfolio.json';

const About = () => {
  const { profileSummary, softSkills } = portfolioData;

  return (
    <section id="about" className="about">
      <h2>About Me</h2>
      <div className="about-content">
        <div className="about-summary">
          {profileSummary.map((paragraph, index) => (
            <p key={index} className="summary-item">
              <span className="bullet">▸</span> {paragraph}
            </p>
          ))}
        </div>
        <div className="soft-skills">
          <h3>Professional Attributes</h3>
          <div className="skills-grid">
            {softSkills.map((skill, index) => (
              <div key={index} className="skill-badge">
                <span className="check-icon">✓</span>
                {skill}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
